module.exports = __webpack_public_path__ + "static/media/integrationManager.7e2c98a4.svg";